import { timeline } from 'motion';
const aa = (prop, from, to, back) => ({
    transitions: {
        entering: { [prop]: [from, to] },
        exiting: { [prop]: [to, back !== null && back !== void 0 ? back : from] }
    }
});
const aaOpacity = () => aa('opacity', 0, 1);
const aaVisibility = () => {
    return {
        transitions: {
            entering: ({ element, duration }) => timeline([
                [element, { opacity: [0, 1] }],
                [element, { opacity: [1, 0.7] }],
                [element, { opacity: [0.7, 1] }]
            ], { duration }),
            exiting: ({ element, duration }) => timeline([
                [element, { opacity: [1, 0] }],
                [element, { opacity: [0, 0.3] }],
                [element, { opacity: [0.3, 0] }]
            ], { duration })
        }
    };
};
export { aa, aaOpacity, aaVisibility };
